import { useState } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  TextField
} from "../../../components";
import { InputErros, PermisoesHelper } from "../../../helpers";
import { EnderecosEstoqueService, notification } from "../../../services";
import { responseErros } from "../../../utils";
import enderecoEstoqueValidator from "../middlewares/endereco-estoque.validator";

const AddEnderecosEstoqueDialog = ({
  id,
  enderecoEstoque,
  setEnderecoEstoque,
  handleCloseDialog,
  openDialog,
  buscaEnderecosEstoque,
  setLoading,
}) => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-pessoas-visualizar");
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const enderecosEstoqueService = new EnderecosEstoqueService();

  const handleInputChange = (e) => {
    e.persist();
    setEnderecoEstoque((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    enderecoEstoqueValidator
      .validate(enderecoEstoque, { abortEarly: false })
      .then(async () => {
        if (id) {
          const response = await enderecosEstoqueService.atualizar(id, enderecoEstoque);
          setLoading(false);
          if (!response.isAxiosError) {
            notification.alteracaoSucesso();
            handleCloseDialog();
            buscaEnderecosEstoque();
          } else responseErros(response);
        } else {
          const response = await enderecosEstoqueService.cadastrar(enderecoEstoque);
          setLoading(false);
          if (!response.isAxiosError) {
            notification.cadastroSucesso();
            buscaEnderecosEstoque();
            handleCloseDialog();
          } else responseErros(response);
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth
      maxWidth="md"
      PaperComponent="div"
      open={openDialog}
      aria-labelledby="form-dialog-title"
    >
      <DialogContent>
        <Card className="p-3">
          <CardHeader title={enderecoEstoque?.id ? "Editar endereço de estoque" : "Cadastrar endereço de estoque"} />
          <CardContent>
            <Grid spacing={2}>
              <TextField
                id="endereco"
                name="endereco"
                label="Descrição do Endereço"
                variant="outlined"
                margin="normal"
                value={enderecoEstoque?.endereco ? enderecoEstoque.endereco : ""}
                onChange={(e) => {
                  setInputErro([]);
                  handleInputChange(e);
                }}
                fullWidth
                required
                error={inputErros.get("descricao")}
              />
            </Grid>
          </CardContent>
          <CardActions>
            <Button
              id="botaoSalvar"
              color="primary"
              variant="contained"
              onClick={handleSubmit}
              disabled={
                !permissoesHelper.temPermisao("produtos-cadastrar")
              }
            >
              <i
                className="ph-fill ph-check-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              ></i>
              Salvar
            </Button>
            <Button
              color="inherit"
              variant="contained"
              onClick={handleCloseDialog}
            >
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              ></i>
              Fechar
            </Button>
          </CardActions>
        </Card>
      </DialogContent>
    </Dialog>
  );
};

export default AddEnderecosEstoqueDialog;
